import React from "react"
import { Link } from "react-router"

export default  function InvestorLink({ id, name }) {
  return <Link to={`/financiers/investors/${id}/detail`} title='Show details'>
    { name }
  </Link>
}



// WEBPACK FOOTER //
// ./src/components/fragments/InvestorLink.js